module.exports = __webpack_public_path__ + "img/belgium-diseases-of-the-nervous-system-male.7e48aaa7.png";